import { createContext } from 'react';

export type CancelTransactionCtx = {
  showCancelTransactionConfirmAlert: boolean;
  showCancelTransactionErrorAlert: boolean;
  sendCancelTransactionError: string;
};

const CancelTransactionDialogueContext = createContext<CancelTransactionCtx>({
  showCancelTransactionConfirmAlert: false,
  showCancelTransactionErrorAlert: false,
  sendCancelTransactionError: '',
});

export default CancelTransactionDialogueContext;